/* eslint-disable func-style  */
import { IPHONE_SCREEN_TYPE, IPAD_SCREEN_TYPE } from '../config/constants';
import viewportSize from './dom/viewport-size';



const GPU_CHIP = {
  S5L8900: 'S5L8900',
  ALP0298C05: 'ALP0298C05',
  POWER_VR_SGX_535: 'PowerVR SGX 535',
  POWER_VR_SGX_543: 'PowerVR SGX 543',
  APPLE_A7_GPU: 'Apple A7 GPU',
  APPLE_A8_GPU: 'Apple A8 GPU',
  APPLE_A9_GPU: 'Apple A9 GPU',
  APPLE_A10_GPU: 'Apple A10 GPU',
  APPLE_A11_GPU: 'Apple A11 GPU',
  APPLE_A12_GPU: 'Apple A12 GPU',
  APPLE_A13_GPU: 'Apple GPU'
};

// https://bitbucket.org/splitmetrics/splitmetrics-data-query/src/master/data_query/data/reference/mobile_devices.json
const MODEL = {
  IPHONE_X_XS_XSMAX_11PRO_11PRO_MAX_12MINI_12PRO_MAX_13MINI_13PRO_MAX: 'iphone_x_xs_xsmax_11pro_11pro_max_12mini_12pro_max_13mini_13pro_max',
  IPHONE_X_XS_11PRO_12MINI_12_12PRO_13MINI_13_13PRO: 'iphone_x_xs_11pro_12mini_12_12pro_13mini_13_13pro',
  IPHONE_12_12PRO_13_13PRO_14_14PRO: 'iphone_12_12pro_13_13pro_14_14pro',
  IPHONE_12PRO_MAX_13PRO_MAX_14PLUS: 'iphone_12promax_13promax_14plus',
  IPHONE_14PRO_MAX_15PRO_MAX_15PLUS_16PLUS: 'iphone_14promax_15promax_15plus_16plus',
  IPHONE_11: 'iphone_11',
  IPHONE_11PRO: 'iphone_11pro',
  IPHONE_11PRO_MAX: 'iphone_11promax',
  IPHONE_XR: 'iphone_xr',
  IPHONE_XSMAX: 'iphone_xsmax',
  IPHONE_X: 'iphone_x',
  IPHONE_XS: 'iphone_xs',
  IPHONE_6: 'iphone_6',
  IPHONE_6S: 'iphone_6S',
  IPHONE_6PLUS: 'iphone_6plus',
  IPHONE_6SPLUS: 'iphone_6s_plus',
  IPHONE_7: 'iphone_7',
  IPHONE_7PLUS: 'iphone_7plus',
  IPHONE_8: 'iphone_8',
  IPHONE_8PLUS: 'iphone_8plus',
  IPHONE_6PLUS_6SPLUS_7PLUS_8PLUS: 'iphone_6plus_6s_plus_7plus_8plus',
  IPHONE_6_6S_7_8: 'iphone_6_6s_7_8',
  IPHONE_5_5C: 'iphone_5_5c',
  IPHONE_5S: 'iphone_5s',
  IPHONE_SE_6S: 'iphone_se_6s',
  IPHONE_5_5C_5S_SE_6_6S_7_8: 'iphone_5_5c_5s_se_6_6s_7_8',
  IPHONE_4: 'iphone_4',
  IPHONE_4S: 'iphone_4s',
  IPHONE_4_4S: 'iphone_4_4s',
  IPHONE_3G: 'iphone_3g',
  IPHONE_1_3GS: 'iphone_1_3gs',
  IPHONE_1_3G_3GS: 'iphone_1_3g_3gs',
  IPHONE_15_15PRO_16: 'iphone_15_15pro_16',
  IPHONE_16_PRO_MAX: 'iphone_16promax',
  IPHONE_16_PRO: 'iphone_16pro'
};

export function detectIphone () {
  if (window.navigator.platform !== 'iPhone' && window.navigator.userAgent && window.navigator.userAgent.indexOf('iPhone') === -1) {
    return null;
  }
  const canvas = document.createElement('canvas');
  let renderer = null;

  if (canvas) {
    const context = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

    if (context) {
      const info = context.getExtension('WEBGL_debug_renderer_info');

      if (info) {
        renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL);
      }
    }
  }

  const height = window.screen.height;
  const width = window.screen.width;
  const pixelRatio = window.devicePixelRatio;

  if (width === 402 && height === 874 && pixelRatio === 3) {
    return { model: MODEL.IPHONE_16_PRO, screen: IPHONE_SCREEN_TYPE.SCREEN_6_5 };
  } else if (width === 440 && height === 956 && pixelRatio === 3) {
    return { model: MODEL.IPHONE_16_PRO_MAX, screen: IPHONE_SCREEN_TYPE.SCREEN_6_5 };
  } else if (width === 393 && height === 852 && pixelRatio === 3) {
    return { model: MODEL.IPHONE_15_15PRO, screen: IPHONE_SCREEN_TYPE.SCREEN_6_5 };
  } else if (width === 320 && height === 693 && pixelRatio === 3) {
    return { model: MODEL.IPHONE_X_XS_11PRO_12MINI_12_12PRO_13MINI_13_13PRO, screen: IPHONE_SCREEN_TYPE.SCREEN_6_5 };
  } else if (width === 390 && height === 844 && pixelRatio === 3) {
    return { model: MODEL.IPHONE_12_12PRO_13_13PRO_14_14PRO, screen: IPHONE_SCREEN_TYPE.SCREEN_6_5 };
  } else if (width === 428 && height === 926 && pixelRatio === 3) {
    return { model: MODEL.IPHONE_12PRO_MAX_13PRO_MAX_14PLUS, screen: IPHONE_SCREEN_TYPE.SCREEN_6_5 };
  } else if (width === 430 && height === 932 && pixelRatio === 3) {
    return { model: MODEL.IPHONE_14PRO_MAX_15PRO_MAX_15PLUS_16PLUS, screen: IPHONE_SCREEN_TYPE.SCREEN_6_5 };
  } else if (width === 414 && height === 896 && pixelRatio === 2) {
    //real screen is 6.1
    switch (renderer) {
      case GPU_CHIP.APPLE_A13_GPU:
        return { model: MODEL.IPHONE_11, screen: IPHONE_SCREEN_TYPE.SCREEN_6_5 };
      default:
        return { model: MODEL.IPHONE_XR, screen: IPHONE_SCREEN_TYPE.SCREEN_6_5 };
    }
  } else if (width === 414 && height === 896 && pixelRatio === 3) {
    switch (renderer) {
      case GPU_CHIP.APPLE_A13_GPU:
        return { model: MODEL.IPHONE_11PRO_MAX, screen: IPHONE_SCREEN_TYPE.SCREEN_6_5 };
      case GPU_CHIP.APPLE_A12_GPU:
        return { model: MODEL.IPHONE_XSMAX, screen: IPHONE_SCREEN_TYPE.SCREEN_6_5 };
      default:
        return { model: MODEL.IPHONE_XSMAX, screen: IPHONE_SCREEN_TYPE.SCREEN_6_5 };
    }
  } else if (width === 375 && height === 812 && pixelRatio === 3) {
    switch (renderer) {
      case GPU_CHIP.APPLE_A11_GPU:
        return { model: MODEL.IPHONE_X, screen: IPHONE_SCREEN_TYPE.SCREEN_5_8 };
      case GPU_CHIP.APPLE_A12_GPU:
        return { model: MODEL.IPHONE_XS, screen: IPHONE_SCREEN_TYPE.SCREEN_5_8 };
      case GPU_CHIP.APPLE_A13_GPU:
        return { model: MODEL.IPHONE_11PRO, screen: IPHONE_SCREEN_TYPE.SCREEN_5_8 };
      default:
        return { model: MODEL.IPHONE_X_XS_XSMAX_11PRO_11PRO_MAX_12MINI_12PRO_MAX_13MINI_13PRO_MAX, screen: IPHONE_SCREEN_TYPE.SCREEN_6_5 };
    }
  } else if (width === 375 && height === 812 && pixelRatio === 2) {
    switch (renderer) {
      case GPU_CHIP.APPLE_A13_GPU:
        return { model: MODEL.IPHONE_XR, screen: IPHONE_SCREEN_TYPE.SCREEN_6_5 };
      default:
        return { model: MODEL.IPHONE_11, screen: IPHONE_SCREEN_TYPE.SCREEN_6_5 };
    }
  } else if (width === 414 && height === 736 && pixelRatio === 3) {
    switch (renderer) {
      case GPU_CHIP.APPLE_A8_GPU:
        return { model: MODEL.IPHONE_6PLUS, screen: IPHONE_SCREEN_TYPE.SCREEN_5_5 };
      case GPU_CHIP.APPLE_A9_GPU:
        return { model: MODEL.IPHONE_6SPLUS, screen: IPHONE_SCREEN_TYPE.SCREEN_5_5 };
      case GPU_CHIP.APPLE_A10_GPU:
        return { model: MODEL.IPHONE_7PLUS, screen: IPHONE_SCREEN_TYPE.SCREEN_5_5 };
      case GPU_CHIP.APPLE_A11_GPU:
        return { model: MODEL.IPHONE_8PLUS, screen: IPHONE_SCREEN_TYPE.SCREEN_5_5 };
      default:
        return { model: MODEL.IPHONE_6PLUS_6SPLUS_7PLUS_8PLUS, screen: IPHONE_SCREEN_TYPE.SCREEN_5_5 };
    }

  } else if (width === 375 && height === 667 && pixelRatio === 3) {
    // Display zoom
    switch (renderer) {
      case GPU_CHIP.APPLE_A8_GPU:
        return { model: MODEL.IPHONE_6, screen: IPHONE_SCREEN_TYPE.SCREEN_4_7 };
      case GPU_CHIP.APPLE_A9_GPU:
        return { model: MODEL.IPHONE_6SPLUS, screen: IPHONE_SCREEN_TYPE.SCREEN_5_5 };
      case GPU_CHIP.APPLE_A10_GPU:
        return { model: MODEL.IPHONE_7PLUS, screen: IPHONE_SCREEN_TYPE.SCREEN_5_5 };
      case GPU_CHIP.APPLE_A11_GPU:
        return { model: MODEL.IPHONE_8PLUS, screen: IPHONE_SCREEN_TYPE.SCREEN_5_5 };
      default:
        return { model: MODEL.IPHONE_6PLUS_6SPLUS_7PLUS_8PLUS, screen: IPHONE_SCREEN_TYPE.SCREEN_5_5 };
    }

  } else if (width === 375 && height === 667 && pixelRatio === 2) {
    switch (renderer) {
      case GPU_CHIP.APPLE_A8_GPU:
        return { model: MODEL.IPHONE_6, screen: IPHONE_SCREEN_TYPE.SCREEN_4_7 };
      case GPU_CHIP.APPLE_A9_GPU:
        return { model: MODEL.IPHONE_6S, screen: IPHONE_SCREEN_TYPE.SCREEN_4_7 };
      case GPU_CHIP.APPLE_A10_GPU:
        return { model: MODEL.IPHONE_7, screen: IPHONE_SCREEN_TYPE.SCREEN_4_7 };
      case GPU_CHIP.APPLE_A11_GPU:
        return { model: MODEL.IPHONE_8, screen: IPHONE_SCREEN_TYPE.SCREEN_4_7 };
      default:
        return { model: MODEL.IPHONE_6_6S_7_8, screen: IPHONE_SCREEN_TYPE.SCREEN_4_7 };
    }

  } else if (width === 320 && height === 568 && pixelRatio === 2) {
    switch (renderer) {
      case GPU_CHIP.POWER_VR_SGX_543:
        return { model: MODEL.IPHONE_5_5C, screen: IPHONE_SCREEN_TYPE.SCREEN_4_0 };
      case GPU_CHIP.APPLE_A7_GPU:
        return { model: MODEL.IPHONE_5S, screen: IPHONE_SCREEN_TYPE.SCREEN_4_0 };
      case GPU_CHIP.APPLE_A8_GPU:
        return { model: MODEL.IPHONE_6, screen: IPHONE_SCREEN_TYPE.SCREEN_4_0 };
      case GPU_CHIP.APPLE_A9_GPU:
        return { model: MODEL.IPHONE_SE_6S, screen: IPHONE_SCREEN_TYPE.SCREEN_4_0 };
      case GPU_CHIP.APPLE_A10_GPU:
        return { model: MODEL.IPHONE_7, screen: IPHONE_SCREEN_TYPE.SCREEN_4_0 };
      case GPU_CHIP.APPLE_A11_GPU:
        return { model: MODEL.IPHONE_8, screen: IPHONE_SCREEN_TYPE.SCREEN_4_0 };
      default:
        return { model: MODEL.IPHONE_5_5C_5S_SE_6_6S_7_8, screen: IPHONE_SCREEN_TYPE.SCREEN_4_0 };
    }

  } else if (width === 320 && height === 480 && pixelRatio === 2) {
    switch (renderer) {
      case GPU_CHIP.POWER_VR_SGX_535:
        return { model: MODEL.IPHONE_4, screen: IPHONE_SCREEN_TYPE.SCREEN_4_0 };
      case GPU_CHIP.POWER_VR_SGX_543:
        return { model: MODEL.IPHONE_4S, screen: IPHONE_SCREEN_TYPE.SCREEN_4_0 };
      default:
        return { model: MODEL.IPHONE_4_4S, screen: IPHONE_SCREEN_TYPE.SCREEN_4_0 };
    }

  } else if (width === 320 && height === 480 && pixelRatio === 1) {
    switch (renderer) {
      case GPU_CHIP.ALP0298C05:
        return { model: MODEL.IPHONE_3G, screen: IPHONE_SCREEN_TYPE.SCREEN_4_0 };
      case GPU_CHIP.S5L8900:
        return { model: MODEL.IPHONE_1_3GS, screen: IPHONE_SCREEN_TYPE.SCREEN_4_0 };
      default:
        return { model: MODEL.IPHONE_1_3G_3GS, screen: IPHONE_SCREEN_TYPE.SCREEN_4_0 };
    }

  } else {
    return null;
  }
}

export function setIphoneParamsGlobaly () {
  const iphone = detectIphone();
  const searchParams = new URLSearchParams(window.location.search);
  const targetScreenSize = searchParams.get('screen_type');

  /*eslint-disable lodash/prefer-lodash-method*/
  if (targetScreenSize && Object.values(IPHONE_SCREEN_TYPE).includes(targetScreenSize)) {
    window.detectedDevice = null;
    window.iphoneScreenSize = targetScreenSize;
    window.document.body.classList.add(targetScreenSize);
  } else if (iphone) {
    window.detectedDevice = iphone.model;
    window.iphoneScreenSize = iphone.screen;
    window.document.body.classList.add(iphone.screen);
  }
}

const IPAD_SIZE = 640;

export const isiPadDevice = () => (viewportSize.width >= IPAD_SIZE && viewportSize.height >= IPAD_SIZE);

const iPhoneScreenTypes = Object.values(IPHONE_SCREEN_TYPE);
const iPadScreenTypes = Object.values(IPAD_SCREEN_TYPE);

export const isiPhoneByScreenType = (screenType) => iPhoneScreenTypes.includes(screenType);

export const isiPadByScreenType = (screenType) => iPadScreenTypes.includes(screenType);



// WEBPACK FOOTER //
// ./src/lib/ios-device-detect.js